import Vuex from 'vuex';
import state from './state';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
  install(Vue) {
    Vue.use(Vuex);

    const store = new Vuex.Store({
      state,
      actions,
      mutations,
      getters,
    });

    // we cannot pass store reference on Vue initialization because the app is a plugin
    Vue.prototype.$store = store;
  },
};
